import { render } from "./Table.vue?vue&type=template&id=14e63a47&scoped=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=14e63a47&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-14e63a47"
/* custom blocks */
import block0 from "./Table.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script